/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { PaymentOrderConfiguration } from './PaymentOrderConfiguration';

export type PaymentOrderTemplate = {
    id: string;
    name: string;
    paymentOrderConfiguration: PaymentOrderConfiguration;
    image?: string;
    transferAllowed: boolean;
    trustedStatus: PaymentOrderTemplate.trustedStatus;
};

export namespace PaymentOrderTemplate {

    export enum trustedStatus {
        NOT_TRUSTED = 'NOT_TRUSTED',
        TRUSTED_REQUESTED = 'TRUSTED_REQUESTED',
        TRUSTED = 'TRUSTED',
    }


}

